export default __webpack_public_path__ + "static/media/dalenfireplace.f329a165.jpg";